module.exports = __webpack_public_path__ + "static/media/Services-04.09f4e374.jpg";